import axios, { handleResponse } from "utils/axios";
import { axiosInstance } from "apis";
import { onGetUserProfile } from "mocksdata/me";

export const login = async (data) => {
  return axios({
    method: "post",
    url: "/auth/login",
    data,
  }).then(handleResponse);
};

export const resetPassword = async (data) => {
  return axios({
    method: "post",
    url: "/auth/request-forgot-password",
    data,
  }).then(handleResponse);
};

export const changeNewPassword = async (data) => {
  return axios({
    method: "post",
    url: "/merchants/reset-password",
    data,
  }).then(handleResponse);
};

export const activeAccount = async (data) => {
  return axios({
    method: "get",
    params: data,
    url: "/auth/verify",
  });
};

export const confirmSupportEmail = async ({ supportEmail, activateCode }) => {
  return axios({
    method: "get",
    url: "/auth/verify-support-email",
    params: { supportEmail, activateCode },
  });
};

export const getProfile = async () => {
  onGetUserProfile();
  return axiosInstance({
    method: "get",
    url: "/users/me",
  }).then(handleResponse);
};
